import { validatePhoneNumber } from '@/utils/validator';

export const validators = {
  phoneNumber: validatePhoneNumber
};

